import React, { Fragment, useEffect, useState } from "react";
import Input from "Components/Input/Input";
import { useDispatch, useSelector } from "react-redux";
import { postRegister } from "Stores/actions";
import showNotify from "Helpers/Notify";
import { useSetState } from "Helpers/Hooks";
import AuthHeader from "../components/AuthHeader";
import MuiButton from "Components/MuiButton/MuiButton";
import codeMask from "Components/Input/components/codeMask";
import Translator from "Languages/Utility/Translator";
import AddressList from "Constants/AddressList";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Grid from "@material-ui/core/Grid";
import * as R from "ramda";
import AppConfig from "Constants/AppConfig";
import {push} from "../../../Helpers/History";
import { useTranslation } from 'react-i18next';
import VerificationInput from "react-verification-input";
import { Checkbox, useTheme } from "@material-ui/core";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
import { read } from "Helpers/LocalStorage";
// import { withGoogleReCaptcha } from "react-google-recaptcha-v3";
import AuthService from "Services/http/endpoints/AuthService";
import StatusHandler from "Helpers/StatusHandler";

// function Register(props) {
function Register() {
  const { t } = useTranslation();
  const { direction } = useTheme();
  const { verifyType, userId, signupToken } = useSelector((state) => ({
    verifyType: state.auth.verifyType,
    userId: state.auth.userId,
    signupToken: state.auth.signupToken,
  }));
  const [formValid, setFormValid] = useState({});
  const [loading, setLoading] = useState(false);
  const [seconds, setSeconds] = useState(120);
  const [checkValid, setCheckValid] = useState(false);

  const dispatch = useDispatch();
  const [state, setState] = useSetState({
    ostan: {
      type: "select",
      selectItems: AddressList.Ostan,
      value: "",
      col: 6,
      validation: null,
    },
    city: {
      type: "select",
      selectItems: [],
      value: "",
      col: 6,
      validation: null,
    },
    authNumber: {
      value: "",
      validation: {
        required: true,
      },
    },
    nameCompany: {
      value: "",
      col: 12,
      validation: {
        required: true,
        minLength: 3,
        firstChar: true,
      },
    },
    identificationCode: {
      value: "",
      col: 12,
      validation: null
    },
    unique: {
      value: "",
      col: 12,
      validation: {
        justEnglish: true,
        required: true,
        minLength: 5,
        maxLength: 70,
      },
    },
  });

  useEffect(() => {
    let timer = null;
    if (seconds > 0) {
      timer = setTimeout(() => {
        setSeconds(seconds - 1);
      }, 1000);
    } else {
      clearTimeout(timer);
      timer = null;
    }
    return () => {
      if(timer) {
        clearTimeout(timer);
      }
    }
  }, [seconds]);

  const setValue = (name, value, validation) => {
    setState({ [name]: { value: convertToEnglishNumber(value) } });
    if(name !== 'identificationCode') setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const onUserAuth = async (e) => {
    e.preventDefault();
    if (!R.isEmpty(formValid) && Object.values(formValid).every((item) => item === true)) {
      const { authNumber, ostan, nameCompany, city, unique, identificationCode } = state;
      try {
        if (verifyType === "signUp") {
          setLoading(true);
          const data = {
            Token: authNumber.value,
            PhoneNumber: userId,
            IdOstan: ostan.value.value,
            IdCity: city.value.value,
            NameCompany: nameCompany.value,
            Unique: unique.value,
            Representative: identificationCode.value,
          };
          await dispatch(postRegister(data, signupToken));
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
        showNotify({
          text: t('invalidInformation'),
          customClass: "error",
        });
      }
    } else {
      if(!formValid.authNumber) {
        showNotify({
          text: t('invalidAuthCode'),
          customClass: "error",
        });
      }
      setCheckValid(true);
    }
  };

  const autoCompleteHandler = (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setState({ [controlName]: { value: value } });
    if (controlName === "ostan") {
      const ctSelectItems = AddressList.city.filter(
        (s) => s.ostan === value.value
      );
      setState({ city: { selectItems: ctSelectItems } });
      setState({ city: { value: ctSelectItems[0] } });
    }
  };

  const onEnter = () => {
    onClear();
    const ct = AddressList.city.find((c) => c.value === AppConfig.defaultCity);
    const pr = AddressList.Ostan.find(
      (o) => o.value === AppConfig.defaultProvince
    );
    const ctSelectItems = AddressList.city.filter(
      (s) => s.ostan === AppConfig.defaultProvince
    );
    setState({ ostan: { value: pr } });
    setState({ city: { value: ct } });
    setState({ city: { selectItems: ctSelectItems } });
  };

  const onClear = () => {
    setFormValid({ nameCompany: false , unique: false , authNumber: false });
    setCheckValid(false);
  };

  const onCancel = () => {
    push("/auth/sign_in");
  }

  const verificationCode = (value) => {
    setValue('authNumber', value, value.length === 5 ? true : false)
  }

  useEffect(() => {
    onClear();
    onEnter();
  }, []);

  const resendCode = async () => {
    try {
      setLoading(true);
      const token = ""; // await props.googleReCaptchaProps?.executeRecaptcha();
      const response = await AuthService.authSingUp({
        Account: read('PNumber'),
        Type: 2,
        keyCap: token,
        CountryId: 1,
      });
      let err = StatusHandler(response);
      if (!err.isFail) {
        setSeconds(120);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <AuthHeader
          title={t('register')}
          description={t('enterInformationCorrectly')}
      />
      <form onSubmit={onUserAuth} className={`register-form ${direction === 'rtl' ? "text-end" : "text-start"}`}>
        <Grid container spacing={1} className="mt-2">
          {Object.keys(state).map((key, index) => {
            return (
              <>
              {
                state[key].type === "select" &&
                <Grid item xs={state[key].col ? state[key].col : 6} key={key + index}>
                  {state[key].type === "select" && (
                    <MuiAutoComplete
                      loading={loading}
                      options={state[key].selectItems}
                      label={<Translator id={key} />}
                      value={state[key].value}
                      id={key}
                      onChange={autoCompleteHandler}
                    />
                  )}
                </Grid>
              }
              </>
            );
          })}
        </Grid>
        <div className="mt-3">
          <Input
            setValue={setValue.bind(this)}
            name="nameCompany"
            validation={state.nameCompany.validation}
            label={<Translator id="name_company" />}
            type="text"
            value={state.nameCompany.value}
            checkValid={checkValid}
          />
        </div>
        <div className="signIn">
          <Input
            setValue={setValue.bind(this)}
            name="unique"
            validation={state.unique.validation}
            label={<Translator id="unique" />}
            type="text"
            value={state.unique.value}
            checkValid={checkValid}
            minLength={state.unique.validation.minLength}
            maxLength={state.unique.validation.maxLength}
          />
        </div>
        <div className="signIn">
          <Input
            setValue={setValue.bind(this)}
            name="identificationCode"
            label={<Translator id="identificationCode" />}
            type="text"
            value={state.identificationCode.value}
          />
        </div>
        {/* <div className="signIn mt-4">
          <Input
            setValue={setValue.bind(this)}
            name="authNumber"
            validation={state.authNumber.validation}
            label={<Translator id="sent_code" />}
            type="text"
            fullWidth
            value={state.authNumber.value}
            inputComponent={codeMask}
            checkValid={checkValid}
          />
        </div> */}
        <div className="VerificationInput mb-3">
          <Translator id="sent_code" />
          <VerificationInput 
            classNames={{character: "VerificationInputCharacter"}}
            validChars="0-9"
            length={5}
            onChange={verificationCode}
            inputProps={{ inputMode: "numeric" }} />
        </div>
        <div className="d-flex flex-column justify-content-center align-items-center g-3 mb-2">
          {
            seconds === 0 ?
            <MuiButton
              className="w-100"
              onClick={resendCode}
              variant="contained"
              title={<Translator id="resend" />}
              disabled={loading}
            /> :  <span className="mt-2">
              {`${t('please_wait_to_receive_the_verification_code')} ${seconds < 10 ? `0${seconds}` : seconds}`}
            </span>
          }
          <MuiButton
            className="w-100"
            type="submit"
            color="primary"
            title={<Translator id="button_save" />}
            disabled={loading}
          />
          <MuiButton
            className="w-100 MuiButtonGrayLight"
            type="submit"
            variant="contained"
            onClick={onCancel}
            title={<Translator id="enseraf" />}
            disabled={loading}
          />
        </div>
      </form>
    </Fragment>
  );
}

export default Register;
// export default withGoogleReCaptcha(Register);